module.exports = __webpack_public_path__ + "img/Drop_down.fc1c7b96.svg";